import { businessSeo, SERVICE_CATALOG } from './businessSeo.js';

export const contactConfig = {
    phone: businessSeo.phoneSchema,
    phoneDisplay: businessSeo.phoneDisplay,
    whatsapp: businessSeo.phoneSchema.replace(/\D/g, ''),
    whatsappMessage: 'Merhaba, kepenk hizmetleri hakkında bilgi almak istiyorum.',
    email: businessSeo.email,
    serviceArea: 'İstanbul geneli mobil servis',

    // Sosyal Medya Linkleri (yalnızca gerçek hesaplar; ölü profiller kaldırıldı)
    socialMedia: {
        instagram: businessSeo.socialProfiles.find((url) => url.includes('instagram.com')) || ''
    },

    // Çalışma Saatleri
    workingHours: {
        weekdays: 'Her gün 09:00-00:00',
        saturday: '09:00-00:00',
        sunday: '09:00-00:00'
    },

    // SEO Bilgileri
    seo: {
        title: 'Olgun Kepenk - Profesyonel Kepenk Sistemleri',
        description: 'İstanbul genelinde otomatik kepenk servisi, kepenk tamiri, bakım ve yeni kepenk çözümleri sunuyoruz.',
        keywords: 'kepenk, otomatik kepenk, kepenk servisi, kepenk tamiri, sıfır kepenk, kepenk parçaları, güvenlik sistemleri',
        ogImage: '/assets/img/og-image.jpg'
    },

    services: SERVICE_CATALOG
}; 
